import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    SetUpdatePassword: "",
    loading: false,
    error: null,
}

const SetUpdatePasswordSlice = createSlice({
    name: "SetUpdatePassword",
    initialState,
    reducers: {
        fetchSetUpdatePasswordSucess: (state, action) => {
            state.loading = false
            state.SetUpdatePassword = action.payload.response;
        },
        fetchSetUpdatePasswordFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
        resetUpdatePasswordState: (state) => { 
            state.SetUpdatePassword = "";
            state.error = null;
        }
    },
})

export const {
    fetchSetUpdatePasswordSucess,
    fetchSetUpdatePasswordFailure,
    resetUpdatePasswordState
} = SetUpdatePasswordSlice.actions;

export default SetUpdatePasswordSlice.reducer;